import {createContext, useState} from "react";
import {
    getCurrentBusDateOrCurrentDate,
    getCurrentDateToDatePickerFormat,
    getPreviousDateToDatePickerFormat
} from "utils/FormatUtils";

export const MNYWIRE_PANEL_HOME_PAGE = "mnyWires-home";

export const Context = createContext({});
const startEndDate = getCurrentBusDateOrCurrentDate();

const initMnyWiresFilterState = {
    status:'ALL',
    startDate: startEndDate,
    endDate: startEndDate
}

const initMnyWiresResultsDisplay = {
    wireSearch:{},
    resData:[]
}

const initMnyWiresPanelPageState = {
    currentPage : MNYWIRE_PANEL_HOME_PAGE,
}


export const Provider = props => {

    const {children} = props;
    const [mnyWiresPanelFilterState, setMnyWiresPanelFilterState] = useState(JSON.parse(JSON.stringify(initMnyWiresFilterState)));
    const [mnyWiresResultsDisplayState, setMnyWiresResultsDisplayState] = useState(JSON.parse(JSON.stringify(initMnyWiresResultsDisplay)));
    const [mnyWiresPanelPageState, setMnyWiresPanelPageState] = useState(JSON.parse(JSON.stringify(initMnyWiresPanelPageState)));
    const [handleApproveFunction, setHandleApproveFunction] = useState(null);
    const [handleRejectFunction, setHandleRejectFunction] = useState(null);
    const [showGridToolbar, setShowGridToolbar] = useState(true);

    const handleApprove = (onSuccess, onError) => {
        handleApproveFunction.handleApprove(
            handleApproveFunction.gridApi, onSuccess, onError);
    }

    const handleReject = (onSuccess, onError) => {
        handleRejectFunction.handleReject(
            handleRejectFunction.gridApi, onSuccess, onError);
    }

    const clearMnyWiresPanelDisplayState = () => {
        const clearMnyWiresPanelFilterState = JSON.parse(JSON.stringify(initMnyWiresFilterState));
        setMnyWiresPanelFilterState(clearMnyWiresPanelFilterState);

        const clearMnyWiresResultsDisplayState = JSON.parse(JSON.stringify(initMnyWiresResultsDisplay));
        setMnyWiresResultsDisplayState(clearMnyWiresResultsDisplayState);

        const clearMnyWiresPanelPageState = JSON.parse(JSON.stringify(initMnyWiresPanelPageState));
        setMnyWiresPanelPageState(clearMnyWiresPanelPageState);

    }
    const displayStatusMapping = {
        "Pend":  "Pend",
        "Appr": "Approved",
        "Cmplt": "Completed",
        "Reject": "Reject",
        "ALL": "ALL"
    }

    const getDisplayStatusFromValue = (value) => {
        if (value){
            return displayStatusMapping[value];
        } else {
            return "";
        }
    }

    const displayMnyWiresPanelPage = (mnyWiresPanelPage) => {
        let mnyWiresPanelPageStateToShow =JSON.parse(JSON.stringify(mnyWiresPanelPageState));
        mnyWiresPanelPageStateToShow.currentPage = mnyWiresPanelPage;
        setMnyWiresPanelPageState(mnyWiresPanelPageStateToShow);
    }

    const mnyWiresPanelContext = {
        mnyWiresPanelFilterState,
        setMnyWiresPanelFilterState,
        mnyWiresResultsDisplayState,
        setMnyWiresResultsDisplayState,
        mnyWiresPanelPageState,
        setMnyWiresPanelPageState,
        showGridToolbar,
        setShowGridToolbar,
        setHandleApproveFunction,
        setHandleRejectFunction,
        displayMnyWiresPanelPage,
        clearMnyWiresPanelDisplayState,
        handleApprove,
        handleReject,
        getDisplayStatusFromValue
    }

    return <Context.Provider value={mnyWiresPanelContext}>{children}</Context.Provider>

};

export const {Consumer} = Context;
